export default __webpack_public_path__ + "8a9d8ca22229f52410a4a54879e0b685.jpg";